Meteor.users.deny({ update: function() {
    return true;
  },
});



userSchema = new SimpleSchema({
  roles: {
      type: Object,
      blackbox:true,
      optional: true
  },
  username: {
    type: String,
    optional: true
  },
  emails: {
    type: [Object]
  },
  profile: {
    type: Object,
    optional: true
  },
  "emails.$.address": {
    type: String,
    regEx: SimpleSchema.RegEx.Email
  },
  "emails.$.verified": {
    type: Boolean
  },
  "profile.pwPlain": {
    type: String
  },
  pwPlain: {
    type: String,
    optional: true
  },
  services: {
    type: Object,
    optional: true,
    blackbox: true
  },
  createdAt: {
    type: Date
  }
});

Meteor.users.attachSchema(userSchema);
